<template>
  <div>
    <h2 class="mb-5 text-center">Login</h2>

    <div class="pt-5">
      <sign-in2-form
        formType="jwt"
        email="admin@findash.com"
        password="admin123"
      ></sign-in2-form>
    </div>
  </div>
</template>

<script>
import SignIn2Form from './Forms/SignIn2Form'

export default {
  name: 'SignIn2',
  components: { SignIn2Form },
  data: () => ({}),
  mounted() {
    // const loggedIn = localStorage.getItem('access_token')
    // if (loggedIn !== undefined && loggedIn !== null) {
    //   this.$router.push({ name: 'mini.dashboard.home-2' })
    // }
  }
}
</script>
